import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingComponent } from 'src/app/demo/components/loading/loading.component';
import { MobileListCardComponent } from 'src/app/demo/components/mobile-list-card/mobile-list-card.component';

@NgModule({
  declarations: [LoadingComponent, MobileListCardComponent],
  imports: [ProgressSpinnerModule],
  exports: [LoadingComponent,]
})
export class SharedComponentsModule { }
